/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ExpandUpProps {
  className?: string;
  width?: number;
  height?: number;
}

const ExpandUpIcon = function ExpandUpIcon({
  className,
  width,
  height,
}: ExpandUpProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="#33363F"
      className={twMerge('w-4 h-4 mr-2 text-[#33363F]', className)}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
};

ExpandUpIcon.defaultProps = {
  className: '',
  width: 24,
  height: 24,
};

export default ExpandUpIcon;
